import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, IconButton } from '@totalsoft/rocket-ui';
import { get, set, over } from '@totalsoft/change-tracking-react';
import { remove } from 'ramda';
import { FlowPermissionType, useFlowPermissions } from '../hooks';
import { usePermissions } from 'providers/RightsHooks';

const TransitionUserGroupListItemComponent = ({ transitionLens, itemLens, index, userGroups }) => {
  const { t } = useTranslation();

  const authorizationCode = useFlowPermissions(FlowPermissionType.WRITE);
  const canWrite = usePermissions(authorizationCode);

  const handleDeleteTransitionUserGroup = useCallback(() => {
    if (window.confirm(t('GenericEntityFlow.DeleteUserGroupQuestion'))) over(transitionLens.userGroups, remove(index, 1));
  }, [t, transitionLens.userGroups, index]);

  return (
    <TableRow>
      <TableCell>
        <Autocomplete
          fullWidth
          isClearable={false}
          simpleValue={true}
          valueKey='id'
          labelKey='name'
          options={userGroups}
          value={itemLens.groupId |> get}
          onChange={itemLens.groupId |> set}
          label={t('ApprovalTypes.ApprovalTypeLevelUserGroup.UserGroup')}
          isSearchable={true}
          disabled={!canWrite || (transitionLens.allowedForAllUserGroups |> get)}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Delete')}
          onClick={handleDeleteTransitionUserGroup}
          disabled={!canWrite || (transitionLens.allowedForAllUserGroups |> get)}
        />
      </TableCell>
    </TableRow>
  );
};

TransitionUserGroupListItemComponent.propTypes = {
  itemLens: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  userGroups: PropTypes.array.isRequired,
  transitionLens: PropTypes.object.isRequired
};

export default React.memo(TransitionUserGroupListItemComponent);
